import { generateKey } from './generateKey';

export const decrypt = async (
  salt: string,
  iv: string,
  passPhrase: string,
  cipherText: string,
  keySize: number,
  iterationCount: number,
) => {
  const CryptoJS = (await import('crypto-js')).default;
  const key = await generateKey(salt, passPhrase, keySize, iterationCount);
  const cipherParams = CryptoJS.lib.CipherParams.create({
    ciphertext: CryptoJS.enc.Base64.parse(cipherText),
  });
  const decrypted = CryptoJS.AES.decrypt(cipherParams, key, {
    iv: CryptoJS.enc.Hex.parse(iv),
  });
  return decrypted.toString(CryptoJS.enc.Utf8);
};
